import React, { type FC } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf } from "@fortawesome/pro-solid-svg-icons";

import styles from "./pdfsNoResults.module.scss";
import NoResultsWithButton from "components/noResultsWithButton/NoResultsWithButton";

export interface PdfsNoResultsProps {
  createButton?: React.ReactElement | null;
  filtered?: boolean;
  title?: string;
  description?: string;
}

const PdfsNoResults: FC<PdfsNoResultsProps> = ({ createButton, filtered, title, description }) => {
  return (
    <NoResultsWithButton
      title={title || "You don't have any PDFs"}
      description={description || "Looks like you don't have any PDFs yet."}
      actionText="the button below to get started."
      icon={<FontAwesomeIcon className={styles.icon} icon={faFilePdf} size="10x" />}
      actionButton={createButton}
      filtered={filtered}
    />
  );
};

export default PdfsNoResults;
